var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-popup',{attrs:{"title":_vm.loadingTitle,"subtitle":_vm.loadingSubtitle}})}
var staticRenderFns = []

export { render, staticRenderFns }